import { useEffect } from "react";

import { variablesGlobales } from "../../../../configs/variables";

export function WompiCheckout({ amountInCents, reference, signature, email, fullName, phone, documento }) {
  useEffect(() => {
    const container = document.getElementById("wompi-container");

    // Limpia contenido previo del contenedor
    if (container) container.innerHTML = "";

    // Crea el script del widget
    const script = document.createElement("script");
    script.src = "https://checkout.wompi.co/widget.js";
    script.async = true;
    script.setAttribute("data-render", "button");
    script.setAttribute("data-public-key", variablesGlobales.pub_key_wompi);
    script.setAttribute("data-currency", "COP");
    script.setAttribute("data-amount-in-cents", amountInCents);
    script.setAttribute("data-reference", reference);
    script.setAttribute("data-signature:integrity", signature);
    // Wompi responde 403 (y el widget se queda cargando) si el redirect-url apunta a localhost, sin
    // importar http/https. En local se omite: el pago igual se procesa, solo que Wompi no devuelve
    // al cliente a la app al terminar. En DEV/PROD la URL es de galilea.co y se envía como siempre.
    const redirectUrl = variablesGlobales.urlRedirectCobre;
    if (redirectUrl && !/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/i.test(redirectUrl)) {
      script.setAttribute("data-redirect-url", redirectUrl);
    }
    //script.setAttribute("data-expiration-time", moment().add(1, 'days').format("YYYY-MM-DDTHH:mm:ss[Z]"));
    script.setAttribute("data-customer-data:email", email);
    script.setAttribute("data-customer-data:full-name", fullName);
    script.setAttribute("data-customer-data:phone-number", phone);
    script.setAttribute("data-customer-data:phone-number-prefix", "+57");
    script.setAttribute("data-customer-data:legal-id", documento);
    script.setAttribute("data-customer-data:legal-id-type", "CC");

    // Inserta el script en el contenedor
    if (container) {
      container.appendChild(script);
    }

    // Limpieza al desmontar el componente
    return () => {
      if (container) container.innerHTML = "";
    };
  }, [amountInCents, reference, signature, documento, email, fullName, phone]);

  return (
    <div
      id="wompi-container"
      className="wompi_checkout"
      style={{
        textAlign: "center",
        marginTop: "1rem",
        minHeight: "250px", // Espacio mínimo para que el botón y el iframe carguen
        overflow: "auto",
        width: "100%"
      }}
    />
  );
}
